import React from 'react';
import { FormHelperText } from '@mui/material';
import { useFormikContext } from 'formik';
import FileUpload from '@/components/FileUpload';
import { UPLOAD_FILES_HELP_TEXT } from '@/utils/helperText';

const FileUploadField = ({ loading }) => {
	const { values, setFieldValue } = useFormikContext();

	return (
		<>
			<FileUpload
				files={values.files}
				setFiles={(files) => setFieldValue('files', files)}
				loading={loading}
			/>
			<FormHelperText>{UPLOAD_FILES_HELP_TEXT}</FormHelperText>
		</>
	);
};

export default FileUploadField;
